import {
    DELETE_CONTCACT_REQUEST,
    DELETE_CONTCACT_SUCCESS,
    DELETE_CONTCACT_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteContactReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_CONTCACT_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_CONTCACT_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_CONTCACT_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteContactReducer;
